import { render, staticRenderFns } from "./upload-claim-doc.vue?vue&type=template&id=34cc3e7c&scoped=true&"
import script from "./upload-claim-doc.vue?vue&type=script&lang=js&"
export * from "./upload-claim-doc.vue?vue&type=script&lang=js&"
import style0 from "./upload-claim-doc.vue?vue&type=style&index=0&id=34cc3e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cc3e7c",
  null
  
)

export default component.exports